var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[(_vm.banner)?_c('img',{attrs:{"src":_vm.banner}}):_c('img',{attrs:{"src":require("@/assets/banner1.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }